import { bus } from "@/main";

class DashboardServiceOrderPanelController {
    selected = null;

    constructor(
        context
    ) {
        this.context = context;
    }

    requestPage(id){
        bus.$emit('toPage', id)
    }
}

export default DashboardServiceOrderPanelController